import ReactQuill from "react-quill";
import "./quillstyle.css"
import { StringMap } from "quill";

interface QuillEditorProps {
  modules?: StringMap;
  onChange?: (value: string) => void;
  value: string;
  theme: 'snow' | 'bubble';
  placeholder?: string;
  readOnly?: boolean;
}

const QuillEditor = ({ modules, placeholder = '', onChange = () => { }, theme, value = '', readOnly = false }: QuillEditorProps) =>
  <ReactQuill modules={modules}
    onChange={onChange} placeholder={placeholder} theme={theme}
    value={value} readOnly={readOnly}
  />

export default QuillEditor;